import { patientRegistrationExternalApi } from '@valerahealth/rtk-query'

export const patientRegistrationExternalEnhancedApi =
  patientRegistrationExternalApi
